import { defineMessages } from "react-intl";

const ENTER_VERIFICATION_CODE_FORM = "enter-verification-code-form";

const enterVerificationCodeFormMessages = defineMessages({
  unableToSubmitVerificationCode: {
    id: `${ENTER_VERIFICATION_CODE_FORM}.unable-to-submit-code`,
    defaultMessage:
      "Unable to submit verification code to reset your password. Please try again later."
  },
  requiredVerificationCode: {
    id: `${ENTER_VERIFICATION_CODE_FORM}.required-verification-code`,
    defaultMessage: "Please provide a verification code."
  },
  verificationCode: {
    id: `${ENTER_VERIFICATION_CODE_FORM}.verification-code`,
    defaultMessage: "Verification code",
    description: "Title for verification code text input."
  },
  invalidCode: {
    id: `${ENTER_VERIFICATION_CODE_FORM}.invalid-code`,
    defaultMessage: "The code you entered is incorrect or expired.",
    description: "Text input error for when a code is incorrect or expired."
  },
  emailMessage: {
    id: `${ENTER_VERIFICATION_CODE_FORM}.email-message`,
    defaultMessage:
      "Please enter the verification code sent to <styledUsername>{username}</styledUsername>."
  }
});

export default enterVerificationCodeFormMessages;
